
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Category } from './interfaces/categories.interface';
import { Subcategories } from '../subcategorie/interfaces/subcateories.interface';

@Component({
  selector: 'establishment-main-categories',
  imports: [],
  templateUrl: './categories.component.html',
  styleUrl: './categories.component.css'
})
export class CategoriesComponent {

  @Input() categories: Category[] = [];
  @Output() categorySelected = new EventEmitter<number | null>();
  @Output() subcategorySelected = new EventEmitter<number | null>();
  selectedCategoryId: number | null = null;
  selectedCategory: Category | null = null;
  @Output() filterChanged = new EventEmitter<{
    category: Category | null,
    subcategory: Subcategories | null
  }>();

  selectCategory(category: Category | null): void {
    this.selectedCategory = category;
    this.selectedCategoryId = category?.pg_id ?? null;
    this.categorySelected.emit(this.selectedCategoryId);
    this.filterChanged.emit({
      category: category,
      subcategory: null
    });
  }
  onSubcategorySelected(subcategory: Subcategories | null): void {
    // Maintain the current category when selecting subcategory
    this.filterChanged.emit({
      category: this.selectedCategory, // Keep current category
      subcategory: subcategory
    });
  }

  onCategorySelect(categoryId: number): void {
    // If the same category is clicked again, deselect it
    if (this.selectedCategoryId === categoryId) {
      this.selectedCategoryId = null;
      this.selectedCategory = null;
    } else {
      this.selectedCategoryId = categoryId;
      this.selectedCategory = this.categories.find(cat => cat.pg_id === categoryId) || null;
    }
    this.categorySelected.emit(this.selectedCategoryId);

    // Emit filterChanged event to update products
    this.filterChanged.emit({
      category: this.selectedCategory,
      subcategory: null
    });
  }
  selectAllCategories(): void {
    // Reset selected category
    this.selectedCategoryId = null;
    this.selectedCategory = null;
    this.categorySelected.emit(null);

    // Emit filterChanged event to show all products
    this.filterChanged.emit({
      category: null,
      subcategory: null
    });
  }
}
